export const ActionTypes = {
  setPrice: 'setPrice',
  setLeaseFinance: 'setLeaseFinance',
  setMakes: 'setMakes',
  setModels: 'setModels',
  setAllModels: 'setAllModels',
  setBodyStyle: 'setBodyStyle',
  setFeature: 'setFeature',
  setYear: 'setYear',
  setMileage: 'setMileage',
  setMaxMileage: 'setMaxMileage',
  setFuel: 'setFuel',
  setEngineSize: 'setEngineSize',
  setTransmission: 'setTransmission',
  setDrivetrain: 'setDrivetrain',
  setColour: 'setColour',
  setMembership: 'setMembership',
  setSearchTerms: 'setSearchTerms',
  removeTag: 'removeTag',
  setViewType: 'setViewType',
  setPageIndex: 'setPageIndex',
  setLocation: 'setLocation',
  setDistance: 'setDistance',
  setListingType: 'setListingType',
  clearFilters: 'clearFilters',
  setError: 'setError',
  setSortType: 'setSortType',

  // Listing State
  setListingVehicles: 'setListingVehicles',
  setListingAdditionalInfo: 'setListingAdditionalInfo',
}
